import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  UrlTree,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { AuthService } from '@portal/app/shared/services/auth.service';
import { StorageService } from '@portal/app/shared/services/storage.service';
import { isLoginInProgress, getReturnUrl } from './helpers';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly store: StorageService,
    private readonly authService: AuthService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    if (this.authService.getUser() != null) {
      return true;
    }

    if (isLoginInProgress()) {
      return true;
    }

    const returnUrl = getReturnUrl(state.url);

    this.router.navigate(['/login'], {
      queryParams: returnUrl ? { returnUrl } : {}
    });
    return false;
  }
}
